import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KeywordsRoutingModule } from './keywords-routing.module';
import { KeywordsListComponent } from './keywords-list/keywords-list.component';
import { KeywordsCreateComponent } from './keywords-create/keywords-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [KeywordsListComponent, KeywordsCreateComponent],
  imports: [
    CommonModule,
    KeywordsRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class KeywordsModule { }
